module.exports = __webpack_public_path__ + "static/media/Usage.48f0c045.jpg";